import React from 'react';

import { ModalControl } from "../../context/modal/modal-context";
import ImageWithPlaceholder from './image-with-placeholder';
import { Helpers } from '../../core/src/helpers';

class SMBSliderBoxes extends React.Component {
    constructor(props) {
        super(props);
    }

    renderModalContent() {
        const { modalContent } = this.props.data;
        return(
            <div className="slider-modal-content" dangerouslySetInnerHTML={Helpers.createMarkup(modalContent)}></div>
        )
    }

    render() {
        const { caption, imgSrc, isModal, openStyle, url } = this.props.data;
        const id = caption.toLowerCase().split(' ').join('-');
        return isModal ? (
            <ModalControl
                content={() => this.renderModalContent()}
                modalProps={{className: 'slider-modal'}}
            >
                {(props) => (
                    <div className="price-slider" id={id} onClick={props.openModal}>
                        <ImageWithPlaceholder src={imgSrc} />
                        <span>{caption}</span>
                    </div>
                )}
            </ModalControl>
        ) : (
            <div className="price-slider" id={id} onClick={() => window.open(url, caption, openStyle)}>
                <ImageWithPlaceholder src={imgSrc} />
                <span>{caption}</span>
            </div>
        )
    }
}

export default SMBSliderBoxes;
  
